import React from "react";
import { useApp } from "@/context/AppProvider";
import { Reveal } from "@/components/motion";
import { EditableText, ListControls, AddButton } from "@/components/editable";
import { TEMPLATES } from "@/content";
import { X } from "lucide-react";

export const Skills = () => {
  const { tr, ed, editMode, moveItem, removeItem, addItem } = useApp();
  const groupsPath = ["skills", "groups"];
  const groups = tr.skills.groups;

  return (
    <section data-testid="skills" className="relative py-24 md:py-32" style={{ backgroundColor: "var(--sand)" }}>
      <div className="container-lux">
        <Reveal className="max-w-2xl mb-16">
          <EditableText as="p" path={["skills", "eyebrow"]} value={tr.skills.eyebrow} className="eyebrow mb-4 inline-block" />
          <EditableText as="h2" path={["skills", "title"]} value={tr.skills.title} className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.1] block" style={{ color: "var(--ink)" }} />
        </Reveal>

        <div className="grid md:grid-cols-3 gap-10 md:gap-14">
          {groups.map((g, gi) => {
            const itemsPath = [...groupsPath, gi, "items"];
            return (
              <Reveal key={gi} delay={gi * 0.1}>
                <div className={`relative ${editMode ? "editing-outline" : ""}`}>
                  {editMode && (
                    <ListControls
                      className="absolute -top-3 end-0"
                      onUp={() => moveItem(groupsPath, gi, -1)}
                      onDown={() => moveItem(groupsPath, gi, 1)}
                      onDelete={() => removeItem(groupsPath, gi)}
                      canUp={gi > 0}
                      canDown={gi < groups.length - 1}
                      testid={`skill-group-controls-${gi}`}
                    />
                  )}
                  <EditableText as="h3" path={[...groupsPath, gi, "name"]} value={g.name} className="font-display text-2xl mb-6 pb-3 border-b block" style={{ color: "var(--ink)", borderColor: "rgba(19,19,19,0.12)" }} />
                  <div className="flex flex-wrap gap-2.5">
                    {g.items.map((it, k) => (
                      <span key={k} className="inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-body transition-all duration-300 hover:-translate-y-0.5" style={{ border: "1px solid rgba(19,19,19,0.15)", color: "var(--ink)", backgroundColor: "rgba(255,255,255,0.55)" }}>
                        <EditableText path={[...itemsPath, k]} value={it} />
                        {editMode && (
                          <button onClick={() => removeItem(itemsPath, k)} className="ec-danger rounded-full p-0.5" data-testid={`skill-del-${gi}-${k}`}>
                            <X size={12} />
                          </button>
                        )}
                      </span>
                    ))}
                    {editMode && (
                      <button onClick={() => addItem(itemsPath, TEMPLATES.skillItem.en, TEMPLATES.skillItem.ar)} className="add-btn rounded-full px-3 py-2 text-sm" data-testid={`add-skill-${gi}`}>+</button>
                    )}
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>

        <div className="mt-12">
          <AddButton onClick={() => addItem(groupsPath, TEMPLATES.skillGroup.en, TEMPLATES.skillGroup.ar)} label={ed.addItem} testid="add-skill-group" />
        </div>
      </div>
    </section>
  );
};
